import './bs-legacy'
import './ajaxzip3'
import './zzl-input-image/load'
import './error-highlight'

console.log('register-js')
